import { render, staticRenderFns } from "./imgSingle.vue?vue&type=template&id=ab2642a0&scoped=true"
import script from "./imgSingle.vue?vue&type=script&lang=js"
export * from "./imgSingle.vue?vue&type=script&lang=js"
import style0 from "./imgSingle.vue?vue&type=style&index=0&id=ab2642a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2642a0",
  null
  
)

export default component.exports